import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.775 10L11.525 16.25H9.77499L15.4 10.625H2.52499V9.375H15.4L9.77499 3.75H11.525L17.775 10Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
